import { GET_PROFILE_INFO, SAVE_PROFILE_INFO, SAVE_INVOICE_DETAILS, SAVE_BOOKING_DETAILS, SAVE_MY_BOOKING, SAVE_DASHBOARD_INFO, UPDATE_BOOKING_INFO, IMAGE_UPLOAD_FINISHED } from '../../constants/action-constants';

const INIT_STATE = {
    profileInfo: null,
    savePrfileInfo: null,
    bookingInfo: null,
    bookingHistory: [],
    totalBooking: 0,
    dashboardInfo: null,
    viewBookingDetails: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PROFILE_INFO: {
            return {
                ...state,
                profileInfo: action.payload,
            };
        }
        case SAVE_PROFILE_INFO: {
            return {
                ...state,
                savePrfileInfo: action.payload,
            };
        }
        case IMAGE_UPLOAD_FINISHED: {
            return {
                ...state,
                uploadedImage: action.payload.filename,
            };
        }
        case SAVE_MY_BOOKING: {
            return {
                ...state,
                bookingHistory: action.payload?.resp || [],
                totalBooking: action.payload?.count || 0,
            };
        }
        case UPDATE_BOOKING_INFO: {
            return {
                ...state,
                bookingInfo: action.payload,
            };
        }
        case SAVE_DASHBOARD_INFO: {
            return {
                ...state,
                dashboardInfo: action.payload,
            };
        }
        case SAVE_BOOKING_DETAILS: {
            return {
                ...state,
                viewBookingDetails: action.payload,
            };
        }
        case SAVE_INVOICE_DETAILS: {
            return {
                ...state,
                invoiceDetails: action.payload,
            };
        }
        default:
            return state;
    }
};
